import { NotifEnum } from '@/models/components/NotifEnum';
import { token, API_BASE_URL, API_O2_URL, BLOB_URL } from '@/services/AuthService';
import { ref } from 'vue';

const profilPictBaseUrl = BLOB_URL + "users-img/";

const formatIsoDate = (dateString: any) => {
  const localeDate = setLocale(dateString);
  const date = new Date(localeDate);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const showIsoTime = (dateString: any) => {
  const localeDate = setLocale(dateString);
  const date = new Date(localeDate);
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}h${minutes}`;
};

const showIsoDateTime = (dateString: any) => {
  const localeDate = setLocale(dateString);
  const date = new Date(localeDate);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}h${minutes}`;
};

const showDateTime = (dateString: any) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}h${minutes}`;
};

const setLocale = (dateString: any) => {
  let date = new Date(dateString + 'Z');
  return date.toISOString();
}

const getShortUser = (userName: string) => {
  let fullName = userName.split(' ');
  let shortName = fullName[0];
  if (fullName.length > 1)
    shortName = fullName[1].slice(0, 1).toUpperCase();
  else
    return shortName;

  return fullName[0] + " " + shortName + ".";
}

const notifMessage = ref('');
const notifType = ref();
const notifId = ref(0);

const showNotif = (message: string, type: NotifEnum) => {
  notifMessage.value = message;
  notifType.value = type;
  notifId.value = Math.random();
}

const isLoading = ref(false);

const getApi = async (url: string, loading?: boolean) => {
  if (loading === undefined || loading === null)
    isLoading.value = true;
  else
    isLoading.value = loading ? true : false;

  try {
    const query = await fetch(`${API_BASE_URL}${url}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token.value}`,
        'Content-Type': 'application/json',
      },
    });
    const json = await query.json();
    isLoading.value = false;
    return json;
  } catch (error) {
    isLoading.value = false;
    console.log(error);
  }
};

const postApi = async (url: string, data: any) => {
  isLoading.value = true;
  try {
    const query = await fetch(`${API_BASE_URL}${url}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token.value}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    isLoading.value = false;
    const json = query.json();
    return json;
  } catch (error) {
    isLoading.value = false;
    console.log(error);
    showNotif("Le serveur est en maintenance, veuillez réessayer plus tard.", NotifEnum.ERROR);
  }
};

const postApiNode = async (url: string, data: any) => {
  isLoading.value = true;
  try {
    const query = await fetch(`${API_O2_URL}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    isLoading.value = false;
    const json = query.json();
    return json;
  } catch (error) {
    isLoading.value = false;
    console.log(error);
    showNotif("Le serveur est en maintenance, veuillez réessayer plus tard.", NotifEnum.ERROR);
  }
};

const postFileApi = async (url: string, data: any) => {
  isLoading.value = true;
  try {
    const query = await fetch(`${API_BASE_URL}${url}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token.value}`,
        ContentType: 'multipart/form-data',
      },
      body: data,
    });
    isLoading.value = false;
    const json = query.json();
    return json;
  } catch (error) {
    isLoading.value = false;
    console.log(error);
    showNotif("Le serveur est en maintenance, veuillez réessayer plus tard.", NotifEnum.ERROR);
  }
}

const getFileApi = async (url: string) => {
  isLoading.value = true;
  try {
    const query = await fetch(`${API_BASE_URL}${url}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token.value}`,
        ContentType: 'application/octet-stream',
      },
    });
    isLoading.value = false;
    if (query.status !== 200) {
      return null;
    } else {
      return query.blob();
    }
  } catch (error) {
    isLoading.value = false;
    console.log(error);
    showNotif("Le serveur est en maintenance, veuillez réessayer plus tard.", NotifEnum.ERROR);
  }
};

const checkImgProfilExist = (picture: string) => {
  return profilPictBaseUrl + picture;
}

const countries = ref<string[]>(["France", "Belgique", "Suisse", "Luxembourg", "Allemagne", "Espagne", "Italie", "Portugal", "Royaume-Uni", "Irlande", "Pays-Bas", "Danemark", "Suède", "Norvège", "Finlande", "Autriche", "Pologne", "République tchèque", "Slovaquie", "Hongrie", "Roumanie", "Bulgarie", "Grèce", "Turquie", "Russie", "Ukraine", "Biélorussie", "Lituanie", "Lettonie", "Estonie", "Croatie", "Serbie", "Bosnie-Herzégovine", "Monténégro", "Macédoine du Nord", "Albanie", "Kosovo", "Slovénie", "Chypre", "Malte"]);

export { formatIsoDate, showIsoTime, showDateTime, showIsoDateTime, getApi, postApi, postApiNode, postFileApi, getFileApi, showNotif, checkImgProfilExist, getShortUser, isLoading, notifMessage, notifType, notifId, profilPictBaseUrl, countries }